import { findField } from "./field-builder";
import AttributeInputField from "./attribute-input-field";
import React, { useMemo } from "react";

export const FieldWrapper = ({ attribute, task, readOnlyOverride, isReadOnlyEdit, isCompleted }) => {
    const Field = useMemo(() => {
        return findField(attribute.componentType, task.isCompleted || (attribute.readOnly && !readOnlyOverride) || isCompleted);
    }, [attribute.componentType, attribute.readOnly, isCompleted, readOnlyOverride, task.isCompleted]);

    return (
        <AttributeInputField
            Field={Field}
            isReadOnly={attribute.readOnly && !readOnlyOverride}
            upc={task.upc}
            attribute={attribute}
            isCompleted={task.isCompleted}
            photoWipKey={task.context.photographyWipKey}
            codingWipKey={task.context.codingWipKey}
            disabled={isReadOnlyEdit}
        />
    );
};
